module.exports = __webpack_public_path__ + "static/img/t14.db082247.png";